import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { ssoAPI } from "../../services/portalApi";
import Footer from "../home/footer";
import "../booking/booking.css";

/**
 * /account/sso?code=… — arriving from Forge Retreat Colombia with the same
 * sign-in. We show who they'll continue as; the first time, they agree to
 * a Makua account being made. Nothing from Forge comes with them.
 */
export default function SsoPage() {
  const [params] = useSearchParams();
  const code = params.get("code") || "";
  const navigate = useNavigate();
  const [who, setWho] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!code) { setError("This link is incomplete."); return; }
    ssoAPI.peek(code).then(setWho).catch((e) => setError(e.message));
  }, [code]);

  const go = async () => {
    setBusy(true); setError("");
    try { await ssoAPI.consume(code, true); navigate("/account", { replace: true }); }
    catch (e) { setError(e.message); setBusy(false); }
  };

  return (
    <>
      <div className="mk-page grain-bg-light">
        <div className="mk-wrap">
          <p className="mk-eyebrow">Your account</p>
          {error ? (
            <>
              <h1 className="mk-title">This link can't be used.</h1>
              <p className="mk-muted mk-sub">{error}</p>
              <div className="mk-actions"><Link className="mk-btn mk-btn--primary" to="/account">Sign in to Makua</Link></div>
            </>
          ) : !who ? (
            <p className="mk-muted" style={{ minHeight: "40vh" }}>One moment…</p>
          ) : (
            <>
              <h1 className="mk-title">Continue as {who.name || who.email}</h1>
              {who.name && <p className="mk-muted mb-0">{who.email}</p>}
              <p className="mk-muted mk-sub">
                {who.hasAccount
                  ? `You're signed in at ${who.from}. Continue to your Makua account with the same sign-in.`
                  : `You're signed in at ${who.from}. Continuing makes a Makua account with your name and email, and nothing else from ${who.from}.`}
              </p>
              <div className="mk-actions">
                <button type="button" className="mk-btn mk-btn--primary" disabled={busy} onClick={go}>
                  {busy ? "Signing you in…" : who.hasAccount ? "Continue" : "Make my account and continue"}
                </button>
                <Link className="mk-btn mk-btn--ghost" to="/account">Use a different account</Link>
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}
